import { stateOfficerRoleMap } from "../../config/roleConfig";
import Officers from "./Officers";

const NodalOfficers = () => {
  return (
    <Officers
      roleIds={Object.values(stateOfficerRoleMap).map(role => role.value)}
      pageTitle="State Officers"
      district={false}
    />
  );
};

export default NodalOfficers;
